import { Outlet } from "react-router-dom";
import Nav from "./Nav";

const Wrapper = (props) => {
  return (
    <>
      <Nav data={props.data} />
      <Outlet context={props.data} />
    </>
  );
};

export default Wrapper;
